export default "__VITE_ASSET__DtN2g4uY__"